export enum ErrorCodeInfo {

    InvalidForm = 1,
    InvalidFormSubmission = 7,
}
